import styled from 'styled-components/macro';

export const NumberCell = styled.div`
  justify-content: flex-end;
  text-align: right;
`;
